import { render, staticRenderFns } from "./BusinessHoursUpdate.vue?vue&type=template&id=6f4675b0&scoped=true&"
import script from "./BusinessHoursUpdate.vue?vue&type=script&lang=js&"
export * from "./BusinessHoursUpdate.vue?vue&type=script&lang=js&"
import style0 from "./BusinessHoursUpdate.vue?vue&type=style&index=0&id=6f4675b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4675b0",
  null
  
)

export default component.exports